import { render, staticRenderFns } from "./Occupancy.vue?vue&type=template&id=2054101e"
import script from "./Occupancy.vue?vue&type=script&lang=js"
export * from "./Occupancy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports